import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from "@angular/core";

@Component({
    selector: "ece-btn-basic",
    template: "",
    standalone: false
})
export class EceButtonComponent implements OnInit {
  @ViewChild("template", { static: true }) template;
  /** The html title of the button. */
  @Input() title = "";
  /** The inner text of the button. */
  @Input() text = "";
  /** Sets the button to a disabled state. */
  @Input() disabled = false;
  /** Sets the button to a hidden state. */
  @Input() hidden = false;
  /**
   * Handler to be called when the button is clicked by a user.
   *
   * Will also block the emission of the event if `disabled` is true.
   */
  @Output() click = new EventEmitter<Event>();

  /** Appearance style of the button. */
  public primary = false;
  /** Icon style of the button - used in inherit buttons. */
  public icon: string;

  constructor(private viewContainerRef: ViewContainerRef) {}

  /**
   * Set embeddedView to remove ngTemplate tag from dom.
   *
   * @ignore
   *
   * */
  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  /**
   * Emit click event
   * @ignore
   * */
  public onClick(event: Event): void {
    event.stopPropagation();

    if (!this.disabled) {
      this.click.emit(event);
    }
  }
}
